/* GoClove PLP — Swiper: lazy-load and initialization */
(function () {
  if (window.__GOC_PLP_SWIPER__) return;
  window.__GOC_PLP_SWIPER__ = true;

  window.__GOC_PLP__ = window.__GOC_PLP__ || {};
  const GOC = window.__GOC_PLP__;

  function loadSwiperOnce() {
    if (window.Swiper) return Promise.resolve(true);
    if (window.__GOC_SWIPER_LOADING__) return window.__GOC_SWIPER_LOADING__;

    window.__GOC_SWIPER_LOADING__ = new Promise((resolve) => {
      const cssId = "goc-swiper-css";
      if (!document.getElementById(cssId)) {
        const link = document.createElement("link");
        link.id = cssId;
        link.rel = "stylesheet";
        link.href = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
        document.head.appendChild(link);
      }

      const jsId = "goc-swiper-js";
      if (document.getElementById(jsId)) {
        const wait = () => (window.Swiper ? resolve(true) : setTimeout(wait, 50));
        wait();
        return;
      }

      const s = document.createElement("script");
      s.id = jsId;
      s.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
      s.async = true;
      s.onload = () => resolve(!!window.Swiper);
      s.onerror = () => resolve(false);
      document.head.appendChild(s);
    });

    return window.__GOC_SWIPER_LOADING__;
  }

  function ensureCardSwiper(el) {
    if (!el || el.__gocSwiperInited) return true;
    if (!window.Swiper) return false;

    el.__gocSwiperInited = true;
    const pag = el.querySelector(".swiper-pagination");
    new Swiper(el, {
      slidesPerView: 1,
      loop: false,
      pagination: pag ? { el: pag, clickable: false } : undefined
    });
    return true;
  }

  function bootSwipers(root) {
    if (window.innerWidth >= 990) return;
    const { SELECTORS, qsa } = GOC;
    let tries = 0;
    (function attempt() {
      const swipers = qsa(root, SELECTORS.swiper);
      let allOk = true;
      swipers.forEach((el) => { if (!ensureCardSwiper(el)) allOk = false; });
      if (!allOk && tries < 25) { tries += 1; setTimeout(attempt, 200); }
    })();
  }

  Object.assign(GOC, { loadSwiperOnce, ensureCardSwiper, bootSwipers });
})();
